(() => {
  const PROJECT_ID = 'qgr92v2qiv';
  const SCRIPT_ID = 'gs-savor-clarity';
  const CONFIG = window.GS_THEME_EXPERIMENT_CONFIG || {};
  const ANALYTICS_CONFIG = window.GS_SAVOR_ANALYTICS_CONFIG || {};
  const MAX_PRIVACY_ATTEMPTS = 20;
  const PRIVACY_RETRY_MS = 250;

  let privacyAttempts = 0;
  let loadStarted = false;
  let loadFeaturesRequested = false;

  function textValue(value, fallback = 'unknown') {
    const text = String(value ?? '').trim();
    return text || fallback;
  }

  function getClarity() {
    window.clarity =
      window.clarity ||
      function clarityQueue() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    return window.clarity;
  }

  function setConsent(analyticsAllowed) {
    if (!window.clarity && !analyticsAllowed) return;

    getClarity()('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
    });
  }

  function setSavorTags() {
    const clarity = getClarity();
    const tags = {
      experiment_id: textValue(CONFIG.experimentId),
      experiment_arm: textValue(CONFIG.experimentArm),
      website_version: textValue(CONFIG.websiteVersion),
      page_type: textValue(CONFIG.pageType),
      template_name: textValue(CONFIG.templateName),
      theme_id: textValue(CONFIG.themeId),
      theme_name: textValue(CONFIG.themeName),
      theme_role: textValue(CONFIG.themeRole),
      environment: textValue(ANALYTICS_CONFIG.environment),
      storefront_experience: 'savor',
    };

    Object.entries(tags).forEach(([key, value]) => clarity('set', key, value));
  }

  function loadClarity() {
    if (loadStarted) {
      setConsent(true);
      setSavorTags();
      return;
    }
    loadStarted = true;

    setConsent(true);
    setSavorTags();

    const existingScript = document.querySelector('script[src*="clarity.ms/tag/"]');
    if (existingScript) {
      document.documentElement.dataset.gsClarityStatus = 'tagged_existing';
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
    script.addEventListener('load', () => {
      document.documentElement.dataset.gsClarityStatus = 'ready';
    });
    script.addEventListener('error', () => {
      document.documentElement.dataset.gsClarityStatus = 'failed';
    });

    document.documentElement.dataset.gsClarityStatus = 'loading';
    document.head.appendChild(script);
  }

  function applyPrivacyState() {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return false;

    const analyticsAllowed = privacy.analyticsProcessingAllowed();
    if (analyticsAllowed) {
      loadClarity();
    } else {
      setConsent(false);
      document.documentElement.dataset.gsClarityStatus = 'consent_denied';
    }

    return true;
  }

  function retryPrivacyState() {
    if (applyPrivacyState()) return;

    privacyAttempts += 1;
    if (privacyAttempts >= MAX_PRIVACY_ATTEMPTS) {
      document.documentElement.dataset.gsClarityStatus = 'privacy_api_unavailable';
      return;
    }

    window.setTimeout(retryPrivacyState, PRIVACY_RETRY_MS);
  }

  function requestPrivacyApi() {
    if (applyPrivacyState()) return;

    if (!loadFeaturesRequested && typeof window.Shopify?.loadFeatures === 'function') {
      loadFeaturesRequested = true;
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        () => retryPrivacyState()
      );
      return;
    }

    retryPrivacyState();
  }

  document.addEventListener('visitorConsentCollected', (event) => {
    const analyticsAllowed = event?.detail?.analyticsAllowed === true;
    if (analyticsAllowed) {
      loadClarity();
    } else {
      setConsent(false);
      document.documentElement.dataset.gsClarityStatus = 'consent_denied';
    }
  });

  requestPrivacyApi();
})();
